import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./plugins/i18n";
import { rehydrateFromCookies } from "./utils/cookieBackup";

// Rehydrate localStorage from cookie backup before app initialization
rehydrateFromCookies();

createApp(App).use(router, i18n).mount("#app");
